import { create } from 'zustand';
import { Country } from './countriesService';

interface CountriesStore {
	countries: Country[];
	setCountries: (countries: Country[]) => void;
}

export const useCountriesStore = create<CountriesStore>((set) => ({
	countries: [],
	setCountries: (countries) => set({ countries }),
}));
